import { LBTLabel, LBTSpacer, Section } from '@laborability/components';
import { Box } from '@mui/material';
import useExternalScript from '../../hooks/useExternalScript';
import styled from 'styled-components';

const StyledFrame = styled('div')(({ style }) => ({
  width: '100%',
  minHeight: '100vh',
  height: 'auto',
  border: 'none',
  ...style,
}));

export default function ExEnergyScouter() {
  useExternalScript(
    'https://server.fillout.com/embed/v1/',
  );

  const markup = {
    __html: `
    <div style="margin:0 auto;max-width:980px;min-height:100vh;height:auto;"
      data-fillout-id="py77rqcBdzus"
      data-fillout-embed-type="standard"
      data-fillout-inherit-parameters
      data-fillout-dynamic-resize>
    </div>`,
  };

  return (
    <Section>
      <LBTSpacer spacing={4} />
      <Box>
        <LBTLabel variant="sourceSubtitle">
          Scouter è il servizio di Energy management, messo a disposizione da Dritto, grazie alla partnership con EX-Energy.
        </LBTLabel>
        <LBTSpacer spacing={4} />
        <LBTLabel variant="spGroteskSubtitle">
          Come funziona?
        </LBTLabel>
        <LBTSpacer spacing={1} />
        <LBTLabel variant="bodyText">
          In modo molto semplice, fissi un appuntamento con l’energy manager, carichi le bollette che vuoi analizzare. L’energy manager, grazie all’algoritmo verifica se esiste un <b>potenziale risparmio</b>. In caso di esisto positivo l’appuntamento verrà confermato e nel corso della consulenza ti verrà spiegata la <b>proposta migliorativa</b>, il <b>tipo di risparmio</b>. Sarai così consapevole delle opportunità che hai a disposizione. 
        </LBTLabel>
        <LBTSpacer spacing={2} />
        <LBTLabel variant="bodyText">
          Nel caso in cui l’esito dell’analisi fosse negativo, l’appuntamento verrà annullato.
        </LBTLabel>
      </Box>

      <LBTSpacer spacing={4} />

      <StyledFrame dangerouslySetInnerHTML={markup} />

      <LBTSpacer spacing={8} isFixed />

    </Section>
  );
}
